import { makeStyle } from '../../../utils';
import { rowCenter, h5, black, blackOutline, secondaryOutline, columnCenter, h6, secondary, caption, blackHigh } from '../../../resources/styles';
import view from '../../../Enums';

const styles = {};

styles['container'] = makeStyle([columnCenter, { width: '100%', height: '100%' }]);

styles['header'] = makeStyle([rowCenter, { padding: '29px 36px', borderBottom: `1px solid ${blackOutline.color}`, alignSelf: 'stretch' }], null, { display: 'none' }, view.TAB);

styles['title'] = makeStyle([h5, black, { letterSpacing: '-0.28px', marginLeft: 14 }]);

styles['content'] = makeStyle([columnCenter, { padding: '58px 24px' }]);

styles['box'] = makeStyle({
    ...columnCenter,
    alignSelf: 'stretch',
    borderRadius: 6,
    border: `1px solid ${secondaryOutline.color}`,
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: 770,
    padding: 32,
    margin: '0 auto',    
    ...secondary,
}, { padding: '32px 64px' });

styles['box_title'] = makeStyle([h6, secondary, { letterSpacing: '-0.35px' }]);

styles['box_desc'] = makeStyle([caption, blackHigh, { letterSpacing: '0.2px', maxWidth: 424, marginTop: 8 }]);

styles['footer'] = makeStyle({ width: '100%', zIndex: 100 });

export default styles;